import React from 'react';
import { getOptions } from '../aggregationUtil';
import { newInteractiveFilter } from './interactiveFilter';

const Filter = newInteractiveFilter('country_id', getOptions);

export const CountryInteractiveFilter = ({
  countries,
  aggregationQuery,
  onSelectValue,
  onClearValue,
  label,
  ...additionalProps
}) => (
  <Filter
    options={countries}
    aggregationQuery={aggregationQuery}
    onSelectValue={onSelectValue}
    onClearValue={onClearValue}
    label={label}
    {...additionalProps}
  />
);
